import { render, staticRenderFns } from "./SelectPeople.vue?vue&type=template&id=e3ef8c72&"
import script from "./SelectPeople.vue?vue&type=script&lang=js&"
export * from "./SelectPeople.vue?vue&type=script&lang=js&"
import style0 from "./SelectPeople.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports